import React from 'react'

import {
    GridContainerEstudoPadraoMd,
} from '../estudo-form/EstudoComp'

import EstudoFormComposicaoInventario from '../estudo-form/EstudoFormComposicaoInventario'

import EstudoFormSucessaoVitalicia from '../estudo-form/EstudoFormSucessaoVitalicia'



const GestaoPatrimonialFormSucessao = ( { values, estudo } ) => {

    return (
        <>
            <GridContainerEstudoPadraoMd
                component={
                    <EstudoFormComposicaoInventario
                        values={values}
                        estudo={estudo}
                        gestaoPatrimonial={true}
                    />
                }
            />

            <GridContainerEstudoPadraoMd
                component={
                    <EstudoFormSucessaoVitalicia
                        values={values}
                        estudo={estudo}
                        gestaoPatrimonial={true}
                        //jsonConfiguracao={jsonConfiguracao}
                    />
                }
            />
        </>
    )
}

export default GestaoPatrimonialFormSucessao